/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerCreateMutationRequest, ArchitectsControllerCreateMutationResponse, ArchitectsControllerCreate400, ArchitectsControllerCreate401, ArchitectsControllerCreate403 } from "../../models/architectsController/ArchitectsControllerCreate";

function getArchitectsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/architects` as const }  
  return res
}

/**
 * @summary Create a new architect
 * {@link /api/v1/architects}
 */
export async function architectsControllerCreate(data?: ArchitectsControllerCreateMutationRequest, config: Partial<RequestConfig<ArchitectsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ArchitectsControllerCreateMutationResponse, ResponseErrorConfig<ArchitectsControllerCreate400 | ArchitectsControllerCreate401 | ArchitectsControllerCreate403>, ArchitectsControllerCreateMutationRequest>({ method : "POST", url : getArchitectsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}